export const MAX_RESULTS = 20
export const USER_ID_STORAGE = 'maiaUserId'
export const MESSAGES_STORAGE = 'maiaMessages'
export const SESSION_COOKIE = 'maiaChatSessionId'
